<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import {ref} from "vue";
import DropZone from "@/components/widgets/dropZonePlanilha.vue";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import { driver } from "driver.js"
import "driver.js/dist/driver.css"


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Multiselect, DropZone, Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },

  data() {

    return {
      title: "Tabelas Base Cotação de Frete",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Tabelas Base Cotação de Frete",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      showModalImpPlan: false,
      submittedImpPlan: false,
      loadingFiles: false,

      //Parte regra de frete
      dtListPesqFreteCota: null,
      showRegrasPrecoFrete: false,
      activeTabRegraFrete: 0,
      showFormRegrasPrecoFrete: false,
      formRegraPrecoFrete: {
        id: 0,
        nome: '',
        descricao: '',
        dtIniVigencia: null,
        dtFimVigencia: null,
        regioes: [],
        faixascep: [],
        transp: '',
        regra: '',
        valor: null,
        segto: '',
        fretecotabase_id: null,
        minCarrinho: null,
      },
      faixacep: {
        inicial: '',
        final: ''
      },
      regioes: 'brasil',
      loadingTransp: false,
      dtListPesqTransp: null,
      formattedValue: '0,00',
      emprRegrasFrete: [],
      dtListPesqFreteCotaBase: null,
      regraSelecionada: 'null',

      userPct: null,
      empresaPct: null,
      userLogged: {},
    };
  },

  created() {

    this.userLogged = JSON.parse(localStorage.getItem('user'))

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {

    abrirCotacoes(){
      console.log('abrirCotacoes')
      const routeData = this.$router.resolve('/cotafrts/listnova')
      window.open(routeData.href, '_blank')
    },


    ajuda(){
      console.log('ajuda')
      const driverObj = driver({
        showProgress: true,
        nextBtnText: 'Próximo >',
        prevBtnText: '< Anterior',
        doneBtnText: 'Finalizar',
        steps: [
          { element: '#btnBaixaModPad', popover: { title: 'Download Modelo Padrão', description: 'Baixe o nosso modelo de planilha de fretes para que possa definir os seus valores e parâmetros.' } },
          { element: '#btnImportPlan', popover: { title: 'Importar Modelo', description: 'Após definição de seus valores e parâmetros, importe a planilha e já pode cotar seus fretes.' } },
          { element: '#btnAbrirCotacoes', popover: { title: 'Abrir Cotações', description: 'Acesse as Cotações ou realize novas.' } },

        ]
      })
      driverObj.drive()

    },


    upgradePlano(){
      console.log('upgradePlano')
      this.$router.push('/usuario/perfil/' + this.userLogged.id)
    },

    selecionouFreteCotaBase(event){
      console.log('tabela base selected')
      console.log(event)
      this.formRegraPrecoFrete.fretecotabase_id = event
    },

    pesqFreteCotaBase(evt){
      console.log('pesqfretecotabasetab')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingTransp = true
        // this.empresaData.transp = ''
        api.get(`${getBaseUrl()}api/pesqfretecotabasetab`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios pesqfretecotabasetab')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFreteCotaBase = res.data
        })
      }
    },

    pesqFreteCota(evt){
      console.log('pesqFreteCota')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/pesqfretecota`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFreteCota = res.data
        })
      }
    },

    formNovaRegraPreco(){
      this.showRegrasPrecoFrete = false
      this.showFormRegrasPrecoFrete = true
    },

    modalRegraPreco(){
      console.log('modalRegraPreco')

      api.get(`${getBaseUrl()}api/getregrafrete`).then((res) => {
        // console.log(res.data)
        this.emprRegrasFrete = res.data
      })

      this.showRegrasPrecoFrete = true
    },

    deletarFreteCotaRegra(id) {
      // console.log('deletarFreteCotaRegra')
      // console.log(id)

      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Atenção!',
        text: 'Deseja realmente excluir o registro? Essa ação não pode ser desfeita!',
        showConfirmButton: true,
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar'
      }).then((selected) => {
        if(selected.isConfirmed){
          api.delete(`${getBaseUrl()}api/deleteregrafrete`,  {
            params: {
              empreFreteCotaRegraId: id
            }
          }).then((res) => {
            // console.log('then deletarFreteCotaRegra');
            // console.log(res.data);

            if (res.data.success) {
              Swal.fire({
                position: 'top-end',
                title: 'Sucesso',
                icon: 'success',
                text: 'Regra deletada com sucesso!',
                timer: 3000,
                showCancelButton: false,
                showConfirmButton: false,
              }).then(() => {
                this.modalRegraPreco()
              });
            } else {
              Swal.fire({
                position: 'top-end',
                title: 'Erro na deleção da regra!',
                icon: 'error',
                text: res.data.error,
                timer: 3000,
                showCancelButton: false,
                showConfirmButton: false,
              });
            }
          }).catch((error) => {
            console.error('Erro ao deletar a regra:', error);
            Swal.fire({
              position: 'top-end',
              title: 'Erro!',
              icon: 'error',
              text: 'Ocorreu um erro ao tentar deletar a regra.',
              timer: 3000,
              showCancelButton: false,
              showConfirmButton: false,
            });
          });
        }
      })
    },

    openEditarFreteCotaRegra(id){
      console.log('openEditarFreteCotaRegra')

      let toupdate_fretecotaregra = this.emprRegrasFrete.find((value) => {
        console.log(value.id)
        console.log(id)
        return value.id === id;
      });

      console.log('toupdate_fretecotaregra')
      console.log(toupdate_fretecotaregra)

      this.formRegraPrecoFrete.id = toupdate_fretecotaregra.id
      this.formRegraPrecoFrete.nome = toupdate_fretecotaregra.nome
      this.formRegraPrecoFrete.descricao = toupdate_fretecotaregra.descricao
      this.formRegraPrecoFrete.dtIniVigencia = toupdate_fretecotaregra.dtIniVigencia
      this.formRegraPrecoFrete.dtFimVigencia = toupdate_fretecotaregra.dtFimVigencia
      this.formRegraPrecoFrete.regioes = toupdate_fretecotaregra.regioes ?? []
      this.formRegraPrecoFrete.faixascep = toupdate_fretecotaregra.faixascep ?? []
      this.formRegraPrecoFrete.transp = toupdate_fretecotaregra.transp !== '' ? toupdate_fretecotaregra.transp : ''
      this.formRegraPrecoFrete.regra = toupdate_fretecotaregra.regra
      this.formRegraPrecoFrete.valor = toupdate_fretecotaregra.valor === 0 ? '0,00' : toupdate_fretecotaregra.valor
      this.formRegraPrecoFrete.segto = toupdate_fretecotaregra.segto !== '' ? toupdate_fretecotaregra.segto : ''
      this.formRegraPrecoFrete.minCarrinho = toupdate_fretecotaregra.minCarrinho === 0 ? 'R$ 0,00' : toupdate_fretecotaregra.minCarrinho

      this.showFormRegrasPrecoFrete = true
    },

    checkRegioes() {
      // Remove brasil se uma região for selecionada
      const brasilIndex = this.regioes.indexOf('brasil');
      if (brasilIndex !== -1) {
        this.regioes.splice(brasilIndex, 1);
      }

      this.formRegraPrecoFrete.regioes = this.regioes
    },

    unselectRegioes() {
      if(this.regioes.includes('brasil')){
        this.regioes = []
        this.formRegraPrecoFrete.faixascep = []
        this.regioes = ['brasil']
        this.formRegraPrecoFrete.regioes = this.regioes
      }
    },

    salvarRegraFrete() {
      console.log('salvarRegraFrete...')
      console.log(this.formRegraPrecoFrete)

      //Verificando se já existe uma regra com o nome inserido
      if(this.emprRegrasFrete && this.emprRegrasFrete.filter((value) => {
        console.log(`nome cadastrado ${value.nome}`)
        console.log(`nome informado ${this.formRegraPrecoFrete.nome}`)

        return value.nome === this.formRegraPrecoFrete.nome
      }).length > 0){
        console.log('error: name already taken!')
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Erro!',
          text: 'O nome para a regra já existe, escolha outro nome!',
          timer: 4000,
          showCancelButton: false,
          showConfirmButton: false
        })
      }else{
        //Inicializando validações dos dados preenchidos no formulário
        if (this.formRegraPrecoFrete.nome === '') {
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Erro!',
            text: 'É necessário pelo menos a identificação do NOME da regra!',
            timer: 4000,
            showCancelButton: false,
            showConfirmButton: false
          })
        }else{
          //Verificando regiões informadas
          if(this.formRegraPrecoFrete.regioes.length === 0 && this.formRegraPrecoFrete.faixascep.length === 0){
            Swal.fire({
              position: 'center',
              title: 'Erro!',
              icon: 'warning',
              text: 'É necessário pelo menos a escolha de uma área ou faixa de CEP!',
              timer: 4000,
              showCancelButton: false,
              showConfirmButton: false
            })
          }else{
            //Verificando regra e valor da regra
            if(this.formRegraPrecoFrete.regra === ""){
              Swal.fire({
                position: 'center',
                title: 'Erro!',
                icon: 'warning',
                text: 'É necessário pelo menos a escolha de uma regra!',
                timer: 4000,
                showCancelButton: false,
                showConfirmButton: false
              })
            }else{
              //Caso regra tenha sido alguma que envolve valor, deve possuir um valor mínimo
              if(this.formRegraPrecoFrete.valor === '0,00' && !['fretegratis', 'blocktransp', 'fixartransp', 'menorpreco'].some(regra =>
                  this.formRegraPrecoFrete.regra.includes(regra)
              )){
                Swal.fire({
                  position: 'center',
                  title: 'Erro!',
                  icon: 'warning',
                  text: 'É necessário a definição de um valor para a regra!',
                  timer: 4000,
                  showCancelButton: false,
                  showConfirmButton: false
                })
              }else{
                //Verificando caso regra percentual, valor não pode ultrapassar 100%
                if(this.formRegraPrecoFrete.regra === 'descperc' && (this.formRegraPrecoFrete.valor < 0 || this.formRegraPrecoFrete.valor > 100)){
                  Swal.fire({
                    position: 'center',
                    title: 'Erro!',
                    icon: 'warning',
                    text: 'Valores percentuais não podem ultrapassar 0 ou 100!',
                    timer: 4000,
                    showCancelButton: false,
                    showConfirmButton: false
                  })
                }else{
                  //Verificando particularidades da regra
                  if(this.formRegraPrecoFrete.regra === 'blocktransp' || this.formRegraPrecoFrete.regra === 'fixartransp'){
                    if(this.formRegraPrecoFrete.transp === ''){
                      Swal.fire({
                        position: 'center',
                        title: 'Erro!',
                        icon: 'warning',
                        text: 'É necessário pelo menos a escolha de uma transportadora para a regra escolhida!',
                        timer: 4000,
                        showCancelButton: false,
                        showConfirmButton: false
                      })
                    }
                  }else {
                    //Formatando valor informado para a regra
                    if (this.formRegraPrecoFrete.valor === '0,00') {
                      this.formRegraPrecoFrete.valor = 0.00
                    }else{
                      let valor_regra = 0.00
                      if(this.formRegraPrecoFrete.valor !== null && this.formRegraPrecoFrete.valor !== undefined){
                        valor_regra = this.formatValue(this.formRegraPrecoFrete.valor)
                      }
                      console.log(`valor_regra: ${valor_regra} | type: ${typeof (valor_regra)}`)
                    }

                    //Formatando valor mínimo do carrinho
                    console.log('min carrinho: ' + this.formRegraPrecoFrete.minCarrinho)
                    let valor_carrinho = 0.00
                    console.log(`valor_carrinho: ${valor_carrinho} | type: ${typeof(valor_carrinho)}`)
                    if (this.formRegraPrecoFrete.minCarrinho !== null && this.formRegraPrecoFrete.minCarrinho !== undefined) {
                      valor_carrinho = this.formatValue(this.formRegraPrecoFrete.minCarrinho)
                    }

                    api.post(`${getBaseUrl()}api/saveregrafrete`, {
                      iddata: this.idData,
                      emprRegraFrete: this.formRegraPrecoFrete
                    }).then((res) => {
                      console.log('then salvarRegraFrete')
                      console.log(res.data)

                      if(res.data.success){
                        Swal.fire({
                          position: 'top-end',
                          title: 'Sucesso',
                          icon: 'success',
                          text: 'Regras de frete salvas com sucesso!',
                          timer: 3000,
                          showCancelButton: false,
                          showConfirmButton: false
                        }).then(() => {
                          this.showFormRegrasPrecoFrete = false
                          this.modalRegraPreco()
                        })
                      }else{
                        Swal.fire({
                          position: 'top-end',
                          title: 'Erro!',
                          icon: 'error',
                          text: res.data.error,
                          timer: 3000,
                          showCancelButton: false,
                          showConfirmButton: false
                        })
                      }
                    })
                  }
                }
              }
            }
          }
        }
      }
    },

    formatValue(value) {
      // console.log(`formatValue: ${value}`)
      if (value) {
        const numericValue = parseFloat(value.replace(',', '.'));
        if (!isNaN(numericValue)) {
          return numericValue
        } else {
          return false
        }
      }

      console.log(`formatted value: ${this.formattedValue}`)
    },

    selecionouRegraFrete(event){
      console.log('regra selecionada')
      console.log(event)
      this.formRegraPrecoFrete.regra = event
    },

    selecionouTranspRegraFrete(selected){
      console.log('selecionouTranspRegraFrete')
      console.log(selected)
      this.formRegraPrecoFrete.transp = selected
    },

    selecionouSgtoRegraFrete(selected){
      console.log('selecionouSgtoRegraFrete')
      console.log(selected)
      this.formRegraPrecoFrete.segto = selected
    },

    pesqTransp(evt) {
      console.log('pesqTransp')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingTransp = true
        api.get(`${getBaseUrl()}api/transpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.dtListPesqTransp = res.data
        })
      }
    },

    adicionaFaixaCep(){
      console.log('adicionaFaixaCep')
      console.log(this.faixacep.inicial.length)
      console.log(this.faixacep.final.length)

      if (String(this.faixacep.inicial).length < 8 || String(this.faixacep.final).length < 8){
        console.log('erro faixa de cep...')
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Erro!',
          text: 'Revise as faixas de CEP',
          timer: 4000,
          showCancelButton: false,
          showConfirmButton: false
        })
      }else{
        const novaFaixa = { ...this.faixacep }

        const existe = this.formRegraPrecoFrete.faixascep.some(
            faixa => faixa.inicial === novaFaixa.inicial && faixa.final === novaFaixa.final
        )

        if(!existe){
          this.formRegraPrecoFrete.faixascep.push(novaFaixa)
        }

        this.faixacep.inicial = ''
        this.faixacep.final = ''
      }
    },
    //Fim declaração de funções para regra de frete

    confImpPlan(){
      console.log('confImpPlan')
      this.submittedImpPlan = true
      if (this.dropzoneFile.name){
        this.showModalImpPlan = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/freteimporplan`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.mediasData = res.data[0]
          this.loadingFiles = false

          if (res.data.erro) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Erro Formatação Planilha",
              text: res.data.erro,
              showConfirmButton: true,
            }).then(res => {
              console.log(res)
              this.atualizaDataList()
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações importadas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(res => {
              console.log(res)
              this.atualizaDataList()
            })
          }

        }).catch((err) => {

          console.log('erro axios')
          console.log(err)
          console.log(err.response)
          console.log(err.response.data)

          // let erros = err.response.data.errors
          // console.log(erros)
          // console.log(typeof  erros)
          // let listaErros = []
          // Object.keys(erros).forEach(key => {
          //   console.log(key, erros[key]);
          //   listaErros.push({
          //     'titulo': key,
          //     'mensagem': erros[key]
          //   })
          // });
          // this.errosValid = listaErros
          // this.loadingFiles = false
        })
      }
    },
    

    novaImpPlan(){
      console.log('novaImpPlan')
      if (this.userPct) {
        if (this.empresaPct) {
          if (this.userPct && this.userPct['consumo'] >= this.userPct['limite']) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Limite de consumo excedido, clique no botão abaixo para upgrade",
              showConfirmButton: true,
            }).then((result) => {
              if (result.value) {
                this.$router.push('/usuario/perfil/' + this.userLogged.id)
              }
            })
          } else {
            this.submittedImpPlan = false
            this.showModalImpPlan = true
          }
        } else {
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Pendência de Configuração!',
            text: 'Empresa não definida para usuário atual, favor entrar no seu perfil e definir as informações da empresa.',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Acessar Perfil',
            cancelButtonText: 'Fechar'
          }).then((selected) => {
            if (selected.isConfirmed) {
              const routeData = this.$router.resolve('/usuario/perfil/' + this.userLogged.id)
              window.open(routeData.href, '_blank')
            }
          })
        }
      } else {

        this.submittedImpPlan = false
        this.showModalImpPlan = true
      }
    },
    
    
    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
    },
    
 


    baixarTabelaModelo(){
      api.get(`${getBaseUrl()}api/modelofretecotadownload`, {
        responseType: 'blob'
      }).then(response => {
        console.log('response.data')
        console.log(response.data)

        //Criando link temporário para realizar download
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'econopro-modelo-tabela-V2.xlsx'
        link.click()

        //limpando URL do objeto - limpando memória
        window.URL.revokeObjectURL(link)
      }).catch((error) => {
        console.log('erro ao baixar arquivo')
        console.log(error)
      })
    },


    abrirFreteTrtTda(){
      console.log('abrirFreteTrtTda')
      const routeData = this.$router.resolve(`/cotacaofretesbasetrttda/list`);
      window.open(routeData.href, '_blank')
    },



    abrirFreteTde(){
      console.log('abrirFreteTde')
      const routeData = this.$router.resolve(`/cotacaofretesbasetde/list`);
      window.open(routeData.href, '_blank')
    },



    novaFreteCotaBase(){
      console.log('novaFreteCotaBase')
      this.$router.push(`/cotacaofretesbase/editar/0`)
    },


    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Tabelas Base Cotação de Frete'
    },


    atualizaDataList(){
      console.log('atualizaDataList')
      api.get(`${getBaseUrl()}api/userpct`, {
        params: {
          'tabela': 'fretecotabasetab'
        }
      }).then(response => {
        console.log('response.userpct')
        console.log(response)
        this.userPct = response.data[0]
        this.empresaPct = response.data[1]
      })

      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/fretecotabases`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
      // this.ocorFinalData = row.data
      this.$router.push(`/cotacaofretesbasetab/editar/${row.data.id}`)


    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },



    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-alert show dismissible
             v-if="userPct && userPct.id > 0 && dataList && !loadingFiles"
             :variant="userPct.limite - userPct.consumo <= 10 ? 'danger' : userPct.limite - userPct.consumo <= 50 ? 'warning' : 'info'">
      <a class="dropdown-item "
         @click="upgradePlano"
         href="javascript: void(0);">
        <i class="mdi mdi-alert me-2"></i>Plano atual consumindo {{ userPct.consumo }} unidade(s) das {{ userPct.limite }} contratada(s), <span class="text-warning">clique aqui e faça upgrade agora mesmo.<i class="mdi mdi-rocket-launch ms-2"></i> </span>
      </a>
    </b-alert>

    <div>

      <DxToolbar v-if="!loadingFiles">

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="alignleft"
              hint="TRT TDA"
              :on-click="abrirFreteTrtTda"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="alignright"
              hint="TDE"
              :on-click="abrirFreteTde"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              id="btnBaixaModPad"
              icon="download"
              text="Baixar modelo padrão Econopro"
              type="normal"
              :on-click="baixarTabelaModelo"/>
        </DxItem>


        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              id="btnImportPlan"
              icon="upload"
              text="Importar Planilha"
              type="normal"
              :on-click="novaImpPlan"/>
        </DxItem>


        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              id="btnAbrirCotacoes"
              icon="money"
              text="Abrir Cotações"
              type="normal"
              :on-click="abrirCotacoes"/>
        </DxItem>


        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              id="btnAjuda"
              icon="help"
              style="background-color: #50a5f1; color: white;"
              text="Ajuda"
              type="normal"

              :on-click="ajuda"/>
        </DxItem>


        <b-button variant="outline-info" class="mx-2" @click="abrirFreteTrtTda">
          <i class="bx bx-list-check font-size-16 align-middle me-2" ></i>

        </b-button>

        <b-button variant="outline-info" class="mx-2" @click="abrirFreteTde">
          <i class="bx bx-list-check font-size-16 align-middle me-2" ></i>
          TDE
        </b-button>


<!--        RETIRAR ATE VALIDAR INSERÇÃO MANUAL-->
<!--        <DxItem-->
<!--            location="before"-->
<!--            widget="dxButton">-->

<!--          <DxButton-->
<!--              icon="plus"-->
<!--              hint="Importar arquivo de movimento"-->
<!--              text="Nova Base de Cotação"-->
<!--              :on-click="novaFreteCotaBase"/>-->

<!--        </DxItem>-->

        <!--        <DxItem-->
        <!--            location="before"-->
        <!--            widget="dxButton">-->
        <!--          <DxButton-->
        <!--              icon="plus"-->
        <!--              hint="Importar arquivo de movimento"-->
        <!--              text="Novo Movimento"-->
        <!--              :on-click="novoMov"/>-->
        <!--        </DxItem>-->




      </DxToolbar>

    </div>

    <div class="mt-2">

      <div class="row" v-if="loadingFiles">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <DxDataGrid
          v-if="!loadingFiles"
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"

          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strOcorFinalsList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="descricao"
            caption="Nome Tabela"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="transpnome"
            caption="Nome Transportador"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="transpcnpj"
            caption="CNPJ Transportador"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="left"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="created_by"
            caption="Usuário"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="created_at"
            caption="Criado"
            alignment="right"
            data-type="datetime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>



    <b-modal title="Importar Planilha" v-model="showModalImpPlan" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar planilha</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedImpPlan && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImpPlan = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImpPlan">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal
        v-model="showFormRegrasPrecoFrete"
        size="lg"
        title="Criação de nova regra de preço"
        title-class="font-18"
        hide-footer
    >
      <div>
        <b-card no-body>
          <b-tabs v-model="activeTabRegraFrete" pills card>
            <b-tab title="Dados gerais regra">
              <b-form>

                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <span>Selecionar ID tabela desejada</span>
                      <div class="row">
                        <div class="col-6">
                          <multiselect
                                       @search-change="pesqFreteCotaBase"
                                       @select="selecionouFreteCotaBase"
                                       placeholder="Pesquisar tabela base"
                                       :options="dtListPesqFreteCotaBase"
                                       :searchable="true"
                                       label="id"
                                       track-by="id"
                                       value-prop="id">
                            <template #option="slotProps">
                              <div class="row">
                                <div>
                              <span class="text-info">
                                {{ slotProps.option.id }}
                              </span>
                                  <span class="mx-4">

                              </span>
                                </div>
                                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                                <span class="mx-4">
                            </span>
                                <span class="mx-4">
                            </span>
                                <div class="align-items-end text-end align-content-end">{{ slotProps.option.descricao }}
                                </div>
                              </div>
                            </template>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="formRegraPrecoFreteNome">Nome da regra</label>
                      <input
                          id="formRegraPrecoFreteNome"
                          v-model="formRegraPrecoFrete.nome"
                          type="text"
                          class="form-control"
                          placeholder="Nome da regra">
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="formRegraPrecoFreteDescricao">Descrição breve</label>
                      <input
                          id="formRegraPrecoFreteDescricao"
                          v-model="formRegraPrecoFrete.descricao"
                          type="text"
                          class="form-control"
                          placeholder="Descrição breve da regra">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="dtIniVigencia">Data Início</label>
                      <input
                          id="dtIniFiltro"
                          v-model="formRegraPrecoFrete.dtIniVigencia"
                          type="date"
                          class="form-control"
                          placeholder="Data Início">
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="dtFimVigencia">Data Final</label>
                      <input
                          id="dtFimFiltro"
                          v-model="formRegraPrecoFrete.dtFimVigencia"
                          type="date"
                          class="form-control"
                          placeholder="Data Final">
                    </div>
                  </div>
                </div>
              </b-form>
            </b-tab>


            <b-tab title="Definir região">
              <h5 class="w-100"><strong>Todas as localidades</strong></h5>
              <b-form-group v-slot="{ ariaDescribedby }" class="form-radio-warning">
                <b-form-checkbox v-model="regioes"
                                 :aria-describedby="ariaDescribedby"
                                 name="brasil"
                                 value="brasil"
                                 @change="unselectRegioes">Brasil todo</b-form-checkbox>
              </b-form-group>

              <div class="d-flex flex-wrap gap-2">
                <h5 class="w-100"><strong>Por região</strong></h5>
                <div>
                  <b-form-checkbox
                      v-model="regioes"
                      name="sudeste"
                      value="sudeste"
                      @change="checkRegioes('sudeste')"
                  >
                    Região Sudeste
                  </b-form-checkbox>
                </div>

                <div>
                  <b-form-checkbox
                      v-model="regioes"
                      name="sul"
                      value="sul"
                      @change="checkRegioes('sul')"
                  >
                    Região Sul
                  </b-form-checkbox>
                </div>

                <div>
                  <b-form-checkbox
                      v-model="regioes"
                      name="nordeste"
                      value="nordeste"
                      @change="checkRegioes('nordeste')"
                  >
                    Região Nordeste
                  </b-form-checkbox>
                </div>

                <div>
                  <b-form-checkbox
                      v-model="regioes"
                      name="norte"
                      value="norte"
                      @change="checkRegioes('norte')"
                  >
                    Região Norte
                  </b-form-checkbox>
                </div>

                <div>
                  <b-form-checkbox
                      v-model="regioes"
                      name="centrooeste"
                      value="centrooeste"
                      @change="checkRegioes('centrooeste')"
                  >
                    Região Centro-oeste
                  </b-form-checkbox>
                </div>
              </div>

              <hr>
              <div class="d-flex flex-wrap gap-2 align-items-center">
                <h5 class="w-100"><strong>Adicionar uma faixa de cep específica</strong></h5>

                <b-form-group
                    label="Faixa inicial"
                    label-for="faixa-inicial"
                    class="mb-0 col"
                >
                  <b-form-input
                      v-model="faixacep.inicial"
                      type="text"
                      placeholder="Insira o CEP inicial"
                      class="col-2"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Faixa final"
                    label-for="faixa-final"
                    class="mb-0 col"
                >
                  <b-form-input
                      v-model="faixacep.final"
                      type="text"
                      placeholder="Insira o CEP final"
                      class="col-2"
                  ></b-form-input>
                </b-form-group>

                <b-button variant="success" size="md" @click="adicionaFaixaCep">
                  Adicionar
                </b-button>
              </div>

              <table class="table" v-if="formRegraPrecoFrete.faixascep.length > 0">
                <thead>
                <tr>
                  <th scope="col">Faixa inicial</th>
                  <th scope="col">Faixa final</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="cep in formRegraPrecoFrete.faixascep" :key="cep.id">
                  <td>{{ cep.inicial }}</td>
                  <td>{{ cep.final }}</td>
                </tr>
                </tbody>
              </table>
              <div v-else>
                <p class="text-black-50">Adicione uma faixa de CEP específica caso necessário...</p>
              </div>
            </b-tab>


            <b-tab title="Regra aplicada">
              <div class="col-md-12">
                <div class="mb-3">
                  <h5><strong>Regra a ser aplicada</strong></h5>
                  <div class="row align-items-end">
                    <div class="col-md-6">
                      <b-form-group label="Selecione a regra" label-for="regra-select" class="mb-0">
                        <b-form-select
                            id="regra-select"
                            v-model="regraSelecionada"
                            class="mb-3"
                            @change="selecionouRegraFrete($event)"
                        >
                          <b-form-select-option value="null">-- Selecione uma opção de regra --</b-form-select-option>
                          <b-form-select-option value="descperc">Desconto percentual(%)</b-form-select-option>
                          <b-form-select-option value="descfixo">Desconto fixo(R$)</b-form-select-option>
                          <b-form-select-option value="fretegratis">Frete grátis</b-form-select-option>
                          <b-form-select-option value="blocktransp">Bloquear transportadora</b-form-select-option>
                          <b-form-select-option value="fixartransp">Fixar apenas uma transportadora</b-form-select-option>
                          <b-form-select-option value="menorpreco">Sempre menor preço</b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </div>

                    <div class="col-md-3">
                      <b-form-group label="Valor da regra (fixo ou percentual)" label-for="valor-regra" class="mb-0">
                        <b-form-input
                            id="valor-regra"
                            v-model="formRegraPrecoFrete.valor"
                            placeholder="0,00(R$ ou %)"
                            type="text"
                        ></b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="formRegraPrecoFreteMinCarrinho">Valor mínimo NF-e</label>
                        <input
                            id="formRegraPrecoFreteMinCarrinho"
                            v-model="formRegraPrecoFrete.minCarrinho"
                            type="text"
                            class="form-control"
                            placeholder="R$ 0,00(mínimo)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <span>(Opcional) Selecionar Transportadora</span>
                    <div class="row">
                      <div class="col-6">
                        <multiselect
                            @search-change="pesqTransp"
                            @select="selecionouTranspRegraFrete"
                            placeholder="Pesquisar Segmento"
                            :options="dtListPesqTransp"
                            :searchable="true"
                            label="nome"
                            track-by="nome"
                            value-prop="codigo"
                        >
                          <template v-slot:option="slotProps">
                            <div class="row">
                              <div>
                                <span class="text-info">{{ slotProps.option.codigo }}</span>
                                <span class="mx-4"></span>
                              </div>
                              <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>

                    <div class="row mt-3">
                      <div class="col-6">
                        <span>(Opcional) Seguimento Frete</span>
                        <multiselect
                            id="repres"
                            @search-change="pesqFreteCota"
                            @select="selecionouSgtoRegraFrete"
                            placeholder="Pesquisar seguimento"
                            :options="dtListPesqFreteCota"
                            :searchable="true"
                            label="nome"
                            track-by="nome"
                            value-prop="codigo"
                        >
                          <template #option="slotProps">
                            <div class="row">
                              <div>
                                <span class="text-info">{{ slotProps.option.codigo }}</span>
                                <span class="mx-4"></span>
                              </div>
                              <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                              <div class="align-items-end text-end align-content-end">
                                {{ formatDateTime(slotProps.option.created_at) }}
                              </div>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>

<!--            <b-tab title="Condições">-->
<!--              -->
<!--            </b-tab>-->
          </b-tabs>

          <div class="d-flex justify-content-end mt-8" style="gap: 8px;" v-if="activeTabRegraFrete === 2">
            <b-button size="md" variant="success" class="mr-1" @click="salvarRegraFrete">Salvar</b-button>
            <b-button size="md" variant="danger" class="ml-1" @click="showFormRegrasPrecoFrete = false">Cancelar</b-button>
          </div>
        </b-card>
      </div>
    </b-modal>

    <b-modal
      v-model="showRegrasPrecoFrete"
      size="xl"
      title="Lista de regras de frete"
      title-class="font-18"
      hide-footer
    >
      <div class="d-flex">
        <b-button variant="success" class="mx-auto" @click="formNovaRegraPreco">Criar nova regra de frete</b-button>
      </div>

      <div class="row mt-1">
        <h5>Regras de fretes cadastradas</h5>
        <div class="table-responsive">
          <table class="table align-middle mb-0 table-nowrap">
            <thead class="table-light">
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Nome</th>
              <th scope="col">Criada em</th>
              <th scope="col">Regra</th>
              <th scope="col">Valor Regra</th>
              <th scope="col">Código transportadora</th>
              <th scope="col">Mínimo carrinho</th>
              <th scope="col">Regiões</th>
              <th scope="col">Faixas de CEP</th>
              <th scope="col">Ações</th>
            </tr>
            </thead>

            <tbody>
            <tr v-if="!emprRegrasFrete || !emprRegrasFrete.length" col-span>
              <td colspan="10">
                <b-alert show variant="warning">
                  Nenhuma regra de preço foi definida!
                </b-alert>
              </td>
            </tr>

              <tr v-for="data in emprRegrasFrete" :key="data.id">

                <td>
                  <h5 class="font-size-14 text-truncate" @click="editarToken(data.id)">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                  </h5>
                </td>

                <td>
                  <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.nome }}
                                </span>
                  </h5>
                </td>

                <td>
                  <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDateTime(data.created_at) }}
                                </span>
                  </h5>
                </td>

                <td>
                  <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.regra }}
                                </span>
                  </h5>
                </td>

                <td>
                  <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.regravalor }}
                                </span>
                  </h5>
                </td>

                <td>
                  <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.transp ?? 'Todas'}}
                                </span>
                  </h5>
                </td>

                <td>
                  <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.mincarinho }}
                                </span>
                  </h5>
                </td>


                <td>
                  <h5 class="font-size-14 text-truncate">
                    <table>
                      <tr>
<!--                        <td>{{ `${regiao ?? ''}`}}</td>-->
                        <td>{{ data.regioes ?? '' }}</td>
                      </tr>
                    </table>
                  </h5>
                </td>

                <td>
                  <h5 class="font-size-14 text-truncate">
                    <table>
                      <tr v-for="(faixa, index) in data.faixascep" :key="index">
                        <td >{{ faixa ?? '' }}</td>
                      </tr>
                    </table>
                  </h5>
                </td>

                <td>
                  <div class="button-items">
                    <b-button variant="outline-danger" @click="deletarFreteCotaRegra(data.id)">
                      <i class="mdi mdi-trash-can d-block font-size-16"></i>
                    </b-button>

                    <!--                                <b-button variant="outline-warning" @click="openEditarFreteCotaRegra(data.id)">-->
                    <!--                                  <i class="mdi mdi-pencil d-block font-size-16"></i>-->
                    <!--                                </b-button>-->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </b-modal>

  </Layout>
</template>


<style>
#btnAjuda .dx-icon {
  color: #fff !important;
}
</style>

